import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  TEMPLATE_LAYOUT,
  TEMPLATE_LAYOUT_OPTIONS,
} from "../../constants/dashboard";
import { setActiveLayout } from "../../store/templates/templatesSlice";
import {
  loadHorizontalVideoTemplates,
  loadVerticalVideoTemplates,
} from "../../thunks/dashboardThunks";
import { Modal } from "../common/modal";
import Rail from "../common/Rail";
import Banner from "./Banner";
import TopBar from "./TopBar";

const ContentAreaVideo = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAdmin } = useSelector((state) => state.user);
  const {
    videoTemplateLoading,
    videoTemplate,
    verticalVideoTemplates,
    horizontalVideoTemplates,
    hasMoreVerticalVideoTemplates,
    hasMoreHorizontalVideoTemplates,
    totalUserVideoCount,

    activeLayout,
  } = useSelector((state) => state.templates);
  const isHorizontalLayout = useMemo(
    () => activeLayout === TEMPLATE_LAYOUT.HORIZONTAL,
    [activeLayout]
  );
  const isVerticalLayout = useMemo(
    () => activeLayout === TEMPLATE_LAYOUT.VERTICAL,
    [activeLayout]
  );

  useEffect(() => {
    fetchMore(0);
  }, [isHorizontalLayout, isVerticalLayout]);

  const hasMore = useMemo(() => {
    if (isVerticalLayout) {
      return hasMoreVerticalVideoTemplates;
    }
    return hasMoreHorizontalVideoTemplates;
  }, [
    hasMoreVerticalVideoTemplates,
    hasMoreHorizontalVideoTemplates,
    isVerticalLayout,
  ]);

  const filteredVideos = useMemo(() => {
    return isVerticalLayout ? verticalVideoTemplates : horizontalVideoTemplates;
  }, [verticalVideoTemplates, horizontalVideoTemplates, isVerticalLayout]);

  const trial = useSelector((state) => state?.user?.details?.data?.trial);
  const [image, setImage] = useState();
  const onRecentTemplateClick = (item) => {
    const { id } = item || {};
    setOpen(true);
    filteredVideos.find((item) => {
      if (item.id === id) {
        setImage(item.filePath);
        return item.filePath;
      }
    });
  };

  const fetchMore = (page) => {
    if (isVerticalLayout) {
      dispatch(loadVerticalVideoTemplates(page || 0));
    }
    if (isHorizontalLayout) {
      dispatch(loadHorizontalVideoTemplates(page || 0));
    }
  };
  const [open, setOpen] = useState(false);

  const handleDownload = (image) => {};
  const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    process.env.REACT_APP_SERVER_API_URL + image
  )}&text=${encodeURIComponent(
    "Check out this video that i created through vidboard.ai!"
  )}`;

  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    process.env.REACT_APP_SERVER_API_URL + image
  )}`;

  const linkedInShareUrl = `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
    process.env.REACT_APP_SERVER_API_URL + image
  )}&title=${encodeURIComponent(
    "Check out this video that i created through vidboard.ai!"
  )}`;

  const handleTabChange = (value) => dispatch(setActiveLayout(value));

  return (
    <>
      <div className="w-85 bg-gray-100 p-0 space-y-2 ml-15 min-h-screen">
        <TopBar />
        {/* Your content will go here */}
        <Banner imageUrl="/tool/dashboard/static/images/banner.png" />

        <div className="mx-4">
          <Rail
            items={filteredVideos}
            railTitle={"My Videos"}
            onClicked={onRecentTemplateClick}
            totalCount={totalUserVideoCount}
            fetchMore={fetchMore}
            loading={videoTemplateLoading}
            // isSlider={true}
            isVideoTemplate
            hasMore={hasMore}
            tabs={TEMPLATE_LAYOUT_OPTIONS}
            handleTabChange={handleTabChange}
          />
        </div>
      </div>

      <Modal
        className=""
        center
        open={open}
        onClose={() => setOpen(false)}
        style={{ width: "60%", height: "80%" }}
      >
        <video
          src={
            image?.includes(".webm") ||
            image?.includes("vidboard.ai") ||
            image?.includes("vidboard-ai")
              ? image
              : process.env.REACT_APP_SERVER_API_URL + image
          }
          controls
          autoPlay
          height={400}
          width={400}
        />
        {/* <FacebookShareButton
          hashtag="Check out this video that i created through vidboard.ai!"
          url={process.env.REACT_APP_SERVER_API_URL + image}
        >
          {" "}
          <FacebookIcon size={32} round />
        </FacebookShareButton>

        <LinkedinShareButton
          url={process.env.REACT_APP_SERVER_API_URL + image}
          title="Check out this video that i created through vidboard.ai"
        >
          <LinkedinIcon size={32} round />
        </LinkedinShareButton> */}

        <div className=" flex justify-around my-4">
          <a href={linkedInShareUrl} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon
              icon={faLinkedin}
              size="2xl"
              style={{ color: "#0077b5" }}
              className="hover:pointer"
            />
          </a>
          <a href={facebookShareUrl} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon
              icon={faFacebook}
              size="2xl"
              style={{ color: "#1877F2" }}
              className="hover:pointer"
            />
          </a>
          <a href={twitterShareUrl} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon
              icon={faXTwitter}
              size="2xl"
              style={{ color: "#000000" }}
              className="hover:pointer"
            />
          </a>
          <a
            href="https://www.instagram.com/vidboard.ai/?igsh=MTlmYXAyazB5OTRmYw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faInstagram}
              size="2xl"
              style={{ color: "#e01d72" }}
              className="hover:pointer"
            />
          </a>
        </div>
      </Modal>
    </>
  );
};

export default ContentAreaVideo;
